import React from 'react';
import Select from "../../utils/Select.jsx";

import './SystemSelect.scss';
const accent = 'var(--buy-color)';
const text = 'var(--ea-text, var(--content-secondary, #b8bcc8))';
export default function SystemSelect({ embedded = false, ...props }) {
  const selectedLook = {
    backgroundColor: 'var(--dropdown-selected-bg)',
    color: 'var(--dropdown-selected-fg, var(--buy-color))',
  };
  const hoverLook = {
    backgroundColor: 'var(--dropdown-hover-bg, var(--row-hover))',
    color: 'var(--dropdown-hover-fg, var(--content-primary))',
  };
  const styles = {
    container: base => ({ ...base, position: 'relative', width: '100%', minWidth: 0 }),
    control: (base, state) => ({ ...base, minHeight: 28, height: 28, backgroundColor: embedded ? 'transparent' : 'var(--ea-panel, #252b42)', border: embedded ? '0 !important' : '1px solid var(--ea-border, #3a4156)', borderRadius: 4, boxShadow: 'none', flexWrap: 'nowrap', cursor: 'pointer', '&:hover': { borderColor: accent } }),
    valueContainer: base => ({ ...base, padding: '0 6px !important', height: 26, flex: '1 1 auto', minWidth: 0 }),
    singleValue: base => ({ ...base, color: text, margin: '0 !important', padding: '0 !important', maxWidth: '100%', overflow: 'visible', textOverflow: 'clip', fontSize: 11 }),
    indicatorsContainer: base => ({ ...base, height: 26, flexShrink: 0 }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base, state) => ({ ...base, padding: '0 4px !important', color: state.selectProps.menuIsOpen ? accent : text, ':hover': { color: accent } }),
    menu: base => ({ ...base, position: base.position, margin: '4px 0 !important', border: '1px solid var(--ea-border, #3a4156)', background: 'var(--ea-panel, var(--surface-panel, #252b42))', borderRadius: 5, overflow: 'hidden', zIndex: 100000010 }),
    menuPortal: base => ({ ...base, zIndex: 100000010 }),
    menuList: base => ({ ...base, padding: '0 !important', maxHeight: base.maxHeight }),
    option: (base, state) => {
      if (state.isSelected) {
        return {
          ...base,
          padding: '6px 10px !important',
          fontSize: 11,
          cursor: 'pointer',
          ...selectedLook,
          ':active': selectedLook,
          ':hover': selectedLook,
        };
      }
      if (state.isFocused) {
        return {
          ...base,
          padding: '6px 10px !important',
          fontSize: 11,
          cursor: 'pointer',
          ...hoverLook,
          ':active': hoverLook,
          ':hover': hoverLook,
        };
      }
      return {
        ...base,
        padding: '6px 10px !important',
        fontSize: 11,
        cursor: 'pointer',
        color: text,
        backgroundColor: 'transparent',
        ':active': hoverLook,
        ':hover': hoverLook,
      };
    },
  };
  return <Select {...props}
    className={'platform-select ' + (embedded ? 'platform-select--embedded ' : '') + (props.className || '')} classNamePrefix="platform-select" styles={styles} menuPlacement="auto" menuPosition="fixed" menuPortalTarget={document.body} maxMenuHeight={160} minMenuHeight={80} menuShouldScrollIntoView={false} isSearchable={props.isSearchable ?? false} />;
}
